import dayjs from "dayjs";
export const formatedCurrentDateTime = () => {
  const date = new Date();
  const formatted = dayjs(date).format("YYYY-MM-DD HH:mm");
  return formatted;
};
